<template>
  <div class="page column--central">
    <div class="mv5 column--central">
      <div class="mb4 row--central">
        <img
          :src="clinic.urls.logo"
          class="image--circle image--size-y-5 bc--secondary"
        >
      </div>
      <div class="mb3 fs7 fw4">
        {{ clinic.金安心.fullname }} / {{ clinic.金禾美.fullname }}
      </div>
      <div>
        LINE 外掛模組
      </div>
    </div>
    <div class="mv5 column--central">
      <div class="mb4 row--central">
        <img
          :src="clinic.urls.inncomLogo"
          class="image--circle image--size-y-5 bc--secondary"
        >
      </div>
      <div class="mb3 fs7 fw4">
        創實雲端科技有限公司
      </div>
      <div>
        Inncom Cloud Technology Co., Ltd.
      </div>
    </div>
  </div>
</template>

<script>
import spiderman from '@/spiderman';

export default {
  setup() {
    return {
      clinic: spiderman.clinic,
    };
  },
};
</script>
